import styled, { css } from "styled-components";
import { Image } from "@commonlibs";

export const TableImageRoot = styled(Image)(
    () => css`
        width: 2.25rem;
        height: 2.25rem;
    `,
);
